import { initializeApp } from "firebase/app";
import { getDatabase, ref, set, get } from "firebase/database";
import { getFirestore } from "firebase/firestore"; // ✅ ADD THIS
import { getAuth, createUserWithEmailAndPassword, updatePassword } from "firebase/auth";

const firebaseConfig = {

apiKey: "AIzaSyCrMV7-_Wqza9UDFiZJXICnGKfwNb9-W_g",

authDomain: "react-firebase-38ed6.firebaseapp.com",

projectId: "react-firebase-38ed6",

storageBucket: "react-firebase-38ed6.firebasestorage.app",

messagingSenderId: "146494638824",

appId: "1:146494638824:web:e20b3c5354b6887a6c175d",



};


const app = initializeApp(firebaseConfig);
const db = getDatabase(app); // ✅ for RTDB
const firestore = getFirestore(app); // ✅ for Firestore
const auth = getAuth(app);

export {
  db,
  firestore, // ✅ NEW EXPORT
  auth,
  ref,
  set,
  get,
  createUserWithEmailAndPassword,
  updatePassword
};
